import { Layout, Card, Loading } from 'element-react';
//import SwiperCore, { Navigation, Pagination, Autoplay, Scrollbar, A11y } from 'swiper';
//import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
//import welcomeBannerImg from '../assets/imgs/home-02.png'
//import welcomeBannerImg2 from '../assets/imgs/home-03.jpg'
import welcomeBannerImg from '../assets/imgs/Banners-03.jpg'
import welcomeBannerImg2 from '../assets/imgs/Banners-04.jpg'
import iconoBanner2 from '../assets/imgs/IconBanner2Home.png'

import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

// Importa los estilos modernos de Swiper
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/navigation/navigation.scss';

import { Link } from "react-router-dom";
//SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
SwiperCore.use([Autoplay, Pagination, Navigation]);
export default function HomeSlider({ slidesPerView, spaceBetween, suppliers, Keyboard, Mousewheel, loading }) {
    
    return (
        <>
          <Swiper
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop={true}
            pagination={{ clickable: true }}
            navigation={true}
            className="HomeSlider"
          >
            <SwiperSlide className="homeslide-01">
              <div className='slider-container' style={{ backgroundImage: `url(${welcomeBannerImg})`, width: "99%" }}>
                <div className='banner01-content-Container'>
                  <h1>NORTH AMERICAN B2B <br></br>MARKETPLACE<span className="primary-color">.</span></h1>
                  <div className='circle'></div><h3>B2B Industrial Sourcing Platform</h3>
                  <hr></hr><br></br>
                  <p>Bainub connects industrial buyers with Verified Suppliers to drive nearshoring projects across North America. Find the right 
                    Manufacturing Partners and request quotes instantly. If you're a Manufacturer, showcase your products and capabilities to reach Corporate Buyers.
                  </p>
                </div>
              </div>
            
            </SwiperSlide>
            <SwiperSlide className="homeslide-02">
              <div className='slider-container' style={{ backgroundImage: `url(${welcomeBannerImg2})`, width: "99%" }}>
                <div className='banner02-content-Container'>
                  <div className='container-title-Banner'>
                    <img src={iconoBanner2}/>
                    <h1>CNC & Metal Fabrication Services<span className="primary-color">.</span></h1>
                  </div>
                  <div className='banner-bg-primary'>
                    <div className='circle'></div><h3>Looking for Specialized Metal Fabrication Solutions?</h3>
                  </div>
                  
                  <p style={{marginBottom: '0px'}}>Use our search engine to find verified suppliers for: CNC Machining, Sheet Metal Cutting, Bending, Welding, Assembly, Finishes & Coatings. All in one place.
                    {/* 100% Comission-Free Trading Operations */}
                  </p>
                  <Link to="/search-result-ng/BAINUBMF009/All" className="link-exploreCategory">
                      <p>
                          Expore category ＞
                      </p>
                  </Link>
                </div>
              </div>
            
            </SwiperSlide>
          </Swiper>
        </>
      );
}
